export default __webpack_public_path__ + "award_platinum.5beb0fd8.png";